import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup } from '@angular/forms';
import { Connection } from '@softline/core';
import { Modal, Validators } from '@softline/ui-core';

import { InputComponent } from '@softline/ui-core';
import { NumberInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { ValidationContainerComponent } from '@softline/ui-core';
import { ValidationMessagePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-connection-dialog',
  templateUrl: './connection-dialog.component.html',
  styleUrls: ['./connection-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, ReactiveFormsModule,
    InputComponent,
    NumberInputComponent,
    TranslatePipe,
    ValidationContainerComponent,
    ValidationMessagePipe] })
export class ConnectionDialogComponent implements OnInit, Modal<Connection> {
  close!: (result: Connection) => void;

  form = new UntypedFormGroup({
    name: new UntypedFormControl(undefined),
    host: new UntypedFormControl(undefined, [Validators.required()]),
    port: new UntypedFormControl(undefined, [Validators.min(1), Validators.max(65535)]),
    basePath: new UntypedFormControl(undefined) });

  mode: 'new' | 'edit' = 'new';
  get connection(): Connection {
    return this.form.value;
  }
  set connection(connection: Connection) {
    this.form.reset();
    this.form.patchValue(connection);
  }

  constructor() {}

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: Connection) => void): void {
    this.close = handler;
  }
}
